module.exports = __webpack_public_path__ + "static/media/3photoshoottext.84a75e12.jpg";